import React from 'react';

const VARIANT_CLASS = {
    primary: 'btn btn-primary',
    secondary: 'btn btn-secondary',
    ghost: 'btn btn-ghost',
    surface: 'btn btn-surface',
    danger: 'btn btn-danger',
};

const SIZE_CLASS = {
    sm: 'btn-sm',
    md: '',
    lg: 'btn-lg',
};

function Button({
    children,
    variant = 'surface',
    size = 'md',
    className = '',
    as = 'button',
    ...rest
}) {
    const Component = as;
    const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS.surface;
    const sizeClass = SIZE_CLASS[size] || '';
    const classes = [variantClass, sizeClass, className].filter(Boolean).join(' ').trim();

    return (
        <Component className={classes} {...rest}>
            {children}
        </Component>
    );
}

export default Button;
